<template>
  <Card>
    <Card dis-hover :bordered="false" style="text-align: left">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="50" inline>
        <FormItem label="单位" prop="departmentId">
          <Select clearable transfer filterable v-model="formValidate.departmentId" style="width: 200px"
                  @on-select="onSelect" @on-clear="onClear">
            <Option v-for="(option, index) in deptList" :value="option.indexCode" :key="index">{{option.name}}</Option>
          </Select>
        </FormItem>
        <Button type="primary" @click="addRange" style="float: right">新增</Button>
      </Form>
    </Card>
    <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
    >
      <template #action="{ row, index }">
        <!--          <el-button style="margin-left: 10px" type="text" size="small" @click="gotoInspector(row)">-->
        <!--            设置巡河员-->
        <!--          </el-button>-->
        <el-button style="margin-left: 10px" type="text" size="small" @click="editRange(row)">
          编辑
        </el-button>
        <el-button style="margin-left: 10px" type="text" size="small" @click="rangeDetail(row)">
          详情
        </el-button>
        <Poptip
            transfer
            confirm
            title="确定删除该数据？"
            @on-ok="deleteRange(row)"
            @on-cancel="cancel">
          <el-button style="margin-left: 10px" type="text" size="small">
            删除
          </el-button>
        </Poptip>
      </template>
    </Table>
    <Page style="text-align: right;margin-top: 10px"
          show-sizer
          show-total
          transfer
          :total="dataTotal"
          :page-size="pageSize"
          :page-size-opts="pageSizeOpts"
          :current-page="currentPage"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
    ></Page>
  </Card>
</template>

<script>
export default {
  name: "signRangeSet",
  data() {
    return {
      deptList: [],
      formValidate: {
        departmentId: null
      },
      ruleValidate: {},
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '区县',
          align: 'center',
          // width: '100',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.deptName)
          }
        },
        {
          title: '打卡中心地点',
          align: 'center',
          width: '180',
          render: (h, params) => {
            return h('div', [
              h('Tooltip', {
                props: {
                  content: params.row.centerPointAddress,
                  maxWidth: 300,
                  transfer: true
                }
              }, params.row.centerPointAddress.substring(0, 8) + '...')
            ])
          }
        },
        {
          title: '打卡中心点位',
          align: 'center',
          width: '200',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `[${params.row.centerPointLongitude},${params.row.centerPointLatitude}]`)
          }
        },
        {
          title: '打卡范围（米）',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.radius}`)
          }
        },
        {
          title: '创建时间',
          align: 'center',
          width: '150',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.createTime === null ? '' : this.$moment(params.row.createTime).format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          width: '150',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action'
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  mounted() {
    this.getDepts()
    this.getDutySignConfigsList()
  },
  methods: {
    ok () {
      // this.$Message.info('You click ok');
    },
    cancel () {
      // this.$Message.info('You click cancel');
    },
    // 获取部门
    getDepts() {
      this.$http.get(`/api/getLowerLevelDepts`).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.deptList = res.data
        }
      })
    },
    // 获取列表
    getDutySignConfigsList() {
      let params = {
        deptIndexCode: this.formValidate.departmentId,
        page: this.currentPage,
        size: this.pageSize
      }
      this.$http.post(`/api/getDutySignConfigsList`, params).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
          this.dataTotal = res.data.recordsTotal
        }
      })
    },
    editRange(row) {
      this.$router.push({
        name: 'editRange',
        query: {
          id: row.id,
          deptName: row.deptName
        }
      })
    },
    rangeDetail(row) {
      this.$router.push({
        name: 'rangeDetail',
        query: {
          id: row.id,
          deptName: row.deptName
        }
      })
    },
    addRange() {
      this.$router.push({
        name: 'setRange',
        params: {}
      })
    },
    deleteRange(row) {
      this.$http.delete(`/api/dutySignConfigs/${row.id}`).then(res => {
        console.log(res)
        this.getDutySignConfigsList()
      })
    },
    onSelect(e) {
      // console.log(e)
      this.formValidate.departmentId = e.value
      this.getDutySignConfigsList()
    },
    onClear() {
      this.formValidate.departmentId = null
      this.getDutySignConfigsList()
    },
    pageChange(page) {
      this.currentPage = page
      this.getDutySignConfigsList()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getDutySignConfigsList()
    }
  }
}
</script>

<style scoped lang="less">

</style>
